import { jsxs as l, jsx as e, Fragment as C } from "react/jsx-runtime";
import { Icon as g } from "@blueprintjs/core";
import { IconNames as u } from "@blueprintjs/icons";
import A from "classnames";
import { useRef as L } from "react";
import k from "react-animate-height";
import { Button as T } from "@strata/react-buttons";
import "./main.scss";
import { Spinner as x } from "@strata/react-loading-animation";
import { MessagingBlock as F } from "@strata/react-messaging-block";
const G = ({
  secondaryButtonText: n = "Cancel",
  primaryButtonText: s = "Save",
  onCancelClick: o = void 0,
  onSubmitClick: t = void 0,
  isSubmitting: c = !1
}) => /* @__PURE__ */ l("div", { className: "sds_form-section__footer", children: [
  /* @__PURE__ */ e(
    T,
    {
      className: "margin__right--medium",
      intent: T.Intent.NONE,
      label: n,
      onClick: o
    }
  ),
  /* @__PURE__ */ e(
    T,
    {
      intent: T.Intent.PRIMARY,
      disabled: c,
      type: "submit",
      label: s,
      onClick: t
    }
  )
] }), r = {
  NOT_STARTED: "",
  ACTIVE: "active",
  COMPLETED: "completed",
  WARNING: "warning",
  ERROR: "error"
}, M = 300, N = ({
  sectionTitle: n = "Section Title",
  step: s = void 0,
  progressIndicatorStatus: o = void 0,
  content: t = void 0,
  width: c = "100%",
  onSectionClick: d,
  isOpen: i,
  disabled: a,
  displayFooter: f = !1,
  secondaryButtonText: h = "Cancel",
  primaryButtonText: D = "Save",
  onCancelClick: p,
  onSubmitClick: O,
  isSubmitting: R = !1,
  scrollToTopOnOpen: b = !1,
  scrollOffset: S = 0,
  onAnimationEnd: v = void 0
}) => {
  const E = L(null), z = (m) => {
    if (m === r.COMPLETED)
      return /* @__PURE__ */ e(g, { icon: u.TICK, size: 12 });
    if (m === r.WARNING)
      return /* @__PURE__ */ e(g, { icon: u.WARNING_SIGN, size: 20 });
    if (m === r.ERROR)
      return /* @__PURE__ */ e(g, { icon: u.ERROR, size: 20 });
  };
  return /* @__PURE__ */ l("div", { className: "sds_form-section", ref: E, style: { width: c }, children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: A(
          "sds_form-section__header",
          "sds_form-section__header-accordion",
          { "sds_form-section__header-accordion--disabled": a }
        ),
        onClick: d,
        onKeyDown: (m) => {
          m.key === "Enter" && d(m);
        },
        role: "button",
        tabIndex: 0,
        children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: A(
                "border__radius--circle",
                "margin__right--small",
                {
                  "sds_section-progress__circle": o === r.COMPLETED || o === r.NOT_STARTED || o === r.ACTIVE
                },
                `sds_section-progress__circle--${o}`
              ),
              children: o === r.COMPLETED || o === r.ERROR || o === r.WARNING ? z(o) : s
            }
          ),
          /* @__PURE__ */ e("div", { className: "sds_form-section__title font-semi-bold--uppercase", children: n })
        ]
      }
    ),
    /* @__PURE__ */ l(
      k,
      {
        duration: M,
        height: i ? "auto" : 0,
        className: A({
          "margin__bottom--xx-small": !i
        }),
        onHeightAnimationEnd: (m) => {
          var I;
          b && i && window.scrollTo(0, (((I = E.current) == null ? void 0 : I.offsetTop) ?? 0) - S), v == null || v(m);
        },
        children: [
          /* @__PURE__ */ e("div", { className: "padding__around--medium", children: t }),
          f && /* @__PURE__ */ e(
            G,
            {
              secondaryButtonText: h,
              primaryButtonText: D,
              onCancelClick: p,
              onSubmitClick: O,
              isSubmitting: R
            }
          )
        ]
      }
    )
  ] });
};
N.statuses = r;
N.AnimateDuration = M;
const w = ({
  sectionDataArray: n,
  secondaryButtonText: s = "Cancel",
  primaryButtonText: o = "Save",
  onCancelClick: t = void 0,
  onSubmitClick: c = void 0,
  isSubmitting: d = !1
}) => /* @__PURE__ */ e("div", { children: n.map((i) => /* @__PURE__ */ e(
  N,
  {
    sectionTitle: i.sectionTitle,
    progressIndicatorStatus: i.progressIndicatorStatus,
    step: i.step,
    content: i.content,
    width: i.width,
    onSectionClick: i.onSectionClick,
    isOpen: i.isOpen,
    disabled: i.disabled,
    displayFooter: i.displayFooter,
    scrollToTopOnOpen: i.scrollToTopOnOpen,
    scrollOffset: i.scrollOffset,
    onAnimationEnd: i.onAnimationEnd,
    secondaryButtonText: s,
    primaryButtonText: o,
    onCancelClick: t,
    onSubmitClick: c,
    isSubmitting: d
  },
  i.step
)) });
w.statuses = N.statuses;
w.AnimateDuration = N.AnimateDuration;
const y = ({
  sectionTitle: n = "Section Title",
  rightHeaderContent: s = void 0,
  hoverOverlayText: o = void 0,
  content: t = void 0,
  isLoading: c = !1,
  width: d = "100%",
  className: i = void 0
}) => /* @__PURE__ */ l("div", { className: A("sds_form-section", i), style: { width: d }, children: [
  /* @__PURE__ */ l("div", { className: "sds_form-section__header", children: [
    /* @__PURE__ */ e("div", { className: "sds_form-section__title", children: n }),
    s && /* @__PURE__ */ e("div", { className: "sds_form-section__right-header-content", children: s })
  ] }),
  /* @__PURE__ */ e("div", { className: "sds_form-section__content", children: c ? /* @__PURE__ */ e(
    x,
    {
      size: x.Size.LARGE,
      className: "padding__top--medium padding__bottom--medium"
    }
  ) : /* @__PURE__ */ l(C, { children: [
    o && /* @__PURE__ */ l("div", { className: "sds_form-section__hover-overlay", children: [
      /* @__PURE__ */ e(g, { icon: u.EYE_OFF, size: 32 }),
      /* @__PURE__ */ e("div", { className: "sds_form-section__hover-overlay--text", children: o })
    ] }),
    t
  ] }) })
] }), _ = ({
  rowContent: n = void 0,
  flexDirection: s = "row"
}) => /* @__PURE__ */ e("div", { className: "sds_form-section__row-container", style: { flexDirection: s }, children: n }), q = ({
  icon: n,
  primaryText: s,
  secondaryText: o = void 0,
  additionalContent: t = void 0,
  sectionTitle: c,
  rightHeaderContent: d,
  isLoading: i,
  width: a,
  className: f
}) => /* @__PURE__ */ e(
  y,
  {
    className: f,
    sectionTitle: c,
    isLoading: i,
    width: a,
    rightHeaderContent: d,
    content: /* @__PURE__ */ e(
      F,
      {
        className: "sds_form-section__message",
        size: F.Sizes.MEDIUM,
        icon: n,
        primaryText: s,
        secondaryText: /* @__PURE__ */ l(C, { children: [
          o && /* @__PURE__ */ e("div", { className: "padding__bottom--large", children: o }),
          t && /* @__PURE__ */ e("div", { className: "sds_form-section__message__additional-content padding__bottom--large", children: t })
        ] })
      }
    )
  }
), J = ({
  sectionTitle: n,
  rightHeaderContent: s,
  hoverOverlayText: o,
  rowOneContent: t = void 0,
  rowOneFlexDirection: c = void 0,
  rowTwoContent: d = void 0,
  rowTwoFlexDirection: i = void 0,
  rowThreeContent: a = void 0,
  rowThreeFlexDirection: f = void 0,
  rowFourContent: h = void 0,
  rowFourFlexDirection: D = void 0,
  rowFiveContent: p = void 0,
  rowFiveFlexDirection: O = void 0,
  rowSixContent: R = void 0,
  rowSixFlexDirection: b = void 0,
  isLoading: S,
  width: v,
  className: E
}) => /* @__PURE__ */ e(
  y,
  {
    className: E,
    sectionTitle: n,
    isLoading: S,
    rightHeaderContent: s,
    hoverOverlayText: o,
    width: v,
    content: /* @__PURE__ */ l(C, { children: [
      t && /* @__PURE__ */ e(
        _,
        {
          rowContent: t,
          flexDirection: c
        }
      ),
      d && /* @__PURE__ */ e(
        _,
        {
          rowContent: d,
          flexDirection: i
        }
      ),
      a && /* @__PURE__ */ e(
        _,
        {
          rowContent: a,
          flexDirection: f
        }
      ),
      h && /* @__PURE__ */ e(
        _,
        {
          rowContent: h,
          flexDirection: D
        }
      ),
      p && /* @__PURE__ */ e(
        _,
        {
          rowContent: p,
          flexDirection: O
        }
      ),
      R && /* @__PURE__ */ e(
        _,
        {
          rowContent: R,
          flexDirection: b
        }
      )
    ] })
  }
);
export {
  w as FormAccordion,
  y as FormSection,
  _ as FormSectionRow,
  q as FormSectionWithMessage,
  J as FormSectionWithRows
};
//# sourceMappingURL=index.js.map
